import HeroList from '../components/hero/HeroList';

export default function DCSreen() {
	return (
		<div>
			<HeroList publisher='DC Comics' />
		</div>
	);
}
